var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("app-modal", {
        attrs: {
          width: "500",
          "min-height": "600",
          persistent: "",
          showCard: false,
        },
        scopedSlots: _vm._u([
          {
            key: "extra",
            fn: function () {
              return [
                _vm.showSelectStrategy
                  ? _c(
                      "v-window",
                      {
                        model: {
                          value: _vm.window,
                          callback: function ($$v) {
                            _vm.window = $$v
                          },
                          expression: "window",
                        },
                      },
                      [
                        _c(
                          "v-window-item",
                          { key: "primary", attrs: { value: "primary" } },
                          [
                            _c(
                              "form-template",
                              {
                                ref: "child-component",
                                attrs: {
                                  title: "Edit Guideline Calculation Strategy",
                                  "proceed-button-text": _vm.formHasNext
                                    ? "Next"
                                    : "Save",
                                  "enable-submit": _vm.isValidForm,
                                },
                                on: {
                                  save: _vm.clickSaveForm,
                                  cancel: _vm.clickClearForm,
                                },
                              },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.strategyOptions,
                                            loading: _vm.isLoading,
                                            label:
                                              "Choose a CoFactor Calculation Strategy",
                                            outline: "",
                                          },
                                          model: {
                                            value: _vm.selectedAlgorithm,
                                            callback: function ($$v) {
                                              _vm.selectedAlgorithm = $$v
                                            },
                                            expression: "selectedAlgorithm",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedAlgorithmObject &&
                                    _vm.selectedAlgorithmObject.Description
                                      ? _c("v-flex", { attrs: { xs12: "" } }, [
                                          _vm._v(
                                            "Description:\n                " +
                                              _vm._s(
                                                _vm.selectedAlgorithmObject
                                                  .Description
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.addDefaultValue
                  ? _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          { attrs: { dense: "", dark: "", color: "primary" } },
                          [
                            _c("v-toolbar-title", [
                              _vm._v("Add CoFactor Values"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c("v-flex", { attrs: { xs12: "" } }, [
                                  _vm._v(
                                    "Please provide values and units for the cofactors below."
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-form",
                                  { ref: "valueForm" },
                                  _vm._l(
                                    _vm.formCofactors,
                                    function (cofactor) {
                                      return _c(
                                        "v-flex",
                                        {
                                          key: cofactor.Id,
                                          attrs: { xs12: "" },
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      label:
                                                        cofactor
                                                          .IncludeCofactors
                                                          .length > 1
                                                          ? "CoFactors"
                                                          : "CoFactor",
                                                      items: _vm.formCofactors,
                                                      "item-text": "Name",
                                                      "item-value": "Id",
                                                      disabled: "",
                                                      "persistent-hint":
                                                        cofactor
                                                          .IncludeCofactors
                                                          .length > 1,
                                                      hint:
                                                        "Cofactors are linked to analyte " +
                                                        cofactor.LinkAnalyte
                                                          .Name,
                                                    },
                                                    model: {
                                                      value: cofactor.Id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cofactor,
                                                          "Id",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "cofactor.Id",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                cofactor.IncludeCofactors,
                                                function (includeCofactor) {
                                                  return [
                                                    includeCofactor.Description
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            key: includeCofactor.Id,
                                                            attrs: { xs12: "" },
                                                          },
                                                          [
                                                            _c("v-textarea", {
                                                              attrs: {
                                                                "auto-grow": "",
                                                                rows: "1",
                                                                label:
                                                                  cofactor
                                                                    .IncludeCofactors
                                                                    .length > 1
                                                                    ? "Description for " +
                                                                      includeCofactor.Name
                                                                    : "Description",
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  includeCofactor.Description,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      includeCofactor,
                                                                      "Description",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "includeCofactor.Description",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs6: "",
                                                    "pr-2": "",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "DefaultValue",
                                                      rules: _vm.formRuleValue,
                                                    },
                                                    model: {
                                                      value:
                                                        cofactor.DefaultValue,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cofactor,
                                                          "DefaultValue",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cofactor.DefaultValue",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs6: "" } },
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      label: "Unit",
                                                      items:
                                                        _vm.allUnitsShow(
                                                          cofactor
                                                        ),
                                                      "item-text": "Name",
                                                      "item-value": "Name",
                                                      rules: _vm.formRuleUnit,
                                                    },
                                                    model: {
                                                      value: cofactor.Unit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cofactor,
                                                          "Unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cofactor.Unit",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "" } },
                                  [
                                    _c(
                                      "v-alert",
                                      {
                                        attrs: {
                                          icon: "info",
                                          color: "warning",
                                          value: _vm.wrongData,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Data could not be empty, please check carefully.\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickAddDefaultValues()
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("done")]),
                                _vm._v(
                                  _vm._s(_vm.$t("Button.Save")) + "\n          "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { outline: "", color: "secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancel()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.activate,
          callback: function ($$v) {
            _vm.activate = $$v
          },
          expression: "activate",
        },
      }),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }